import { alpha, createTheme } from '@mui/material/styles';

const brand = {
  primary: '#1976d2',
  primaryDark: '#1565c0',
  primaryLight: '#42a5f5',
  background: '#f8fafc',
  surface: '#ffffff',
  surfaceAlt: '#f3f6fb',
  textPrimary: '#0f172a',
  textSecondary: '#5b6475',
  border: 'rgba(15, 23, 42, 0.12)',
  shadow: 'rgba(15, 23, 42, 0.08)',
  overlay: 'rgba(0, 0, 0, 0.6)'
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brand.primary,
      dark: brand.primaryDark,
      light: brand.primaryLight,
      contrastText: '#ffffff'
    },
    background: {
      default: brand.background,
      paper: brand.surface
    },
    text: {
      primary: brand.textPrimary,
      secondary: brand.textSecondary
    },
    divider: brand.border,
    action: {
      hover: alpha(brand.primary, 0.06),
      selected: alpha(brand.primary, 0.12),
      focus: alpha(brand.primary, 0.14)
    }
  },
  shape: {
    borderRadius: 16
  },
  typography: {
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 800 },
    h4: { fontWeight: 800 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 700 },
    button: {
      textTransform: 'none',
      fontWeight: 700
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: brand.background,
          color: brand.textPrimary
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    },
    MuiButton: {
      styleOverrides: ({ theme }) => ({
        root: {
          borderRadius: theme.shape.borderRadius
        }
      })
    },
    MuiChip: {
      styleOverrides: ({ theme }) => ({
        root: {
          borderRadius: theme.shape.borderRadius
        }
      })
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined'
      }
    },
  }
});

export const brandTokens = brand;
export default theme;
